/**
 * Dizionario en.
 *
 * Inglese.
 *
 * Le chiavi devono essere identiche a quelle di `it`: il test
 * `backend/tests/test_jurisdictions.py::test_le_lingue_dichiarate_sono_quelle_tradotte`
 * confronta i file di questa cartella con `APP_LOCALES`, e
 * `test_b2b_frontend_wiring.py` controlla che ogni chiave usata da un pannello
 * esista in **ogni** lingua. Aggiungere una lingua è quindi un file nuovo qui
 * più il codice in `APP_LOCALES`, non una modifica a `i18n.jsx`.
 */
export default {
  "nav": {
    "showcase": "Showcase",
    "directory": "Properties",
    "network": "Network",
    "pricing": "Pricing",
    "login": "Sign in",
    "signup": "Register property",
    "dashboard": "Dashboard",
    "logout": "Sign out",
    "book": "Book",
    "host_area": "I run a property",
    "find_stay": "Find a stay",
    "bedbank": "Bedbank",
    "claim": "Claim",
    "affiliates": "Affiliates",
    "merchant_area": "Merchant area",
    "merchants": "Merchants",
    "merchant_login": "Merchant login",
    "merchant_login_title": "I run a local business",
    "merchant_space": "Merchant space",
    "host_dashboard": "Host dashboard",
    "account": "Account",
    "language": "Language"
  },
  "landing": {
    "eyebrow": "Platform for hospitality structures",
    "title1": "Italian hospitality,",
    "title2": "worldwide.",
    "subtitle": "Promote your property, sync OTAs, swap rooms with trusted partners. A digital home for B&Bs, farmhouses and hotels.",
    "cta_primary": "Start free",
    "cta_secondary": "Browse showcases",
    "f1_title": "A showcase in seven languages",
    "f1_body": "A public page in Italian, English, Spanish, French, German, Portuguese and Greek that tells your story. Photos, rooms, direct booking via Stripe.",
    "f2_title": "Structure network",
    "f2_body": "Overbooked? Route the guest to a partner. National marketplace + local closed groups.",
    "f3_title": "Group requests",
    "f3_body": "Post a large group request — nearby structures respond. Centralized breakfast included.",
    "f4_title": "Unified calendar",
    "f4_body": "Direct bookings, network rooms, OTAs synced via iCal (coming). Zero overbooking.",
    "f5_title": "PMS included",
    "f5_body": "A full Property Management System inside the platform: front office, reception, housekeeping, kitchen, purchasing and an operations log. No extra software to pay for.",
    "showcase_title": "Featured properties",
    "showcase_sub": "Some of the houses telling their story on Hostaly.",
    "how_title": "How it works",
    "how_1": "Register your property",
    "how_1b": "Sign up in 60 seconds. Auto-verified for MVP.",
    "how_2": "Set up your showcase in seven languages",
    "how_2b": "Copy for every language, photos, services, rooms. Publish when you're ready.",
    "how_3": "Join the network",
    "how_3b": "Offer last-minute rooms, answer group requests, get paid.",
    "final_title": "The digital home of Italian hospitality",
    "final_body": "One platform to manage showcase, network and bookings."
  },
  "auth": {
    "login": "Sign in",
    "register": "Register your property",
    "email": "Email",
    "password": "Password",
    "structure": "Property name",
    "country": "Property country",
    "country_help": "It decides which obligations apply to you. It is not the interface language: that one you choose separately.",
    "cin_label": "CIN code",
    "cin_help": "Italian National Identification Code (MITUR) — mandatory by law (DL 145/2023). National format: IT + 15 chars (17 total). Some regions like Sicily may use longer formats (up to 22 chars). Request it at bdsr.ministeroturismo.gov.it",
    "cin_not_required": "Outside Italy the CIN is not needed: we will ask for your local registration number when the time comes.",
    "submit_login": "Enter",
    "submit_register": "Create account",
    "aff_rules": "Affiliation rules",
    "aff_consent": "I confirm I have read and accept the",
    "aff_consent_hint": "Required to register your property: covers commissions, payments, property obligations and all promotions set out in the contract (clause 6.4).",
    "switch_to_register": "No account? Register your property",
    "switch_to_login": "Already have an account? Sign in",
    "forgot": "Forgot password?",
    "demo_hint": "Demo: demo@hospitalityhub.it / demo1234",
    "staff_title": "Create your account",
    "staff_hint": "The property owner assigned you a role. Use exactly the email address they used: that's what links your account to the role.",
    "staff_name": "Full name",
    "staff_name_help": "Optional. It only helps your colleagues recognise you.",
    "role_label": "Your role in the property",
    "role_general_manager": "General Manager (owner)",
    "role_operations_manager": "Operations Manager",
    "role_manager": "Manager",
    "role_operator": "Operative (housekeeping/kitchen/repairs)",
    "role_help": "Determines what you can do in Hotel Ops. The General Manager manages staff roles.",
    "staff_password_hint": "At least 8 characters.",
    "staff_submit": "Create my account",
    "account_created": "Account created",
    "welcome_back": "Welcome back",
    "cin_invalid": "Invalid CIN code. Must start with 'IT' followed by 14-20 alphanumeric characters.",
    "cin_title": "Starts with IT + 14-20 chars (16-22 total, e.g. Sicily 18)",
    "aff_required": "You must review the Affiliation rules before continuing.",
    "google": "Continue with Google",
    "apple": "Continue with Apple",
    "soon": "soon",
    "google_unavailable": "Google login unavailable",
    "google_not_configured": "Google sign-in is not configured on this installation. Use email and password; the key (GOOGLE_CLIENT_ID / GOOGLE_CLIENT_SECRET) must be added on the server.",
    "apple_failed": "Apple sign-in failed",
    "contract_docx": "Download the full contract (DOCX)",
    "costs_title": "What Hostaly costs you",
    "costs_body": "No sign-up fee. The commission applies to every booking, and drops with the plan.",
    "to_staff": "Assigned a role in a property? Create your account here",
    "host_plans": "Host plans",
    "pick_plan": "Pick the plan that fits"
  },
  "dash": {
    "welcome": "Welcome,",
    "overview": "Overview",
    "property": "Property",
    "rooms": "Rooms",
    "bookings": "Bookings",
    "marketplace": "Network",
    "groups": "Group requests",
    "reviews": "Ratings",
    "ical": "OTA Sync",
    "swaps": "Swaps",
    "breakfast": "Breakfast",
    "total_bookings": "Total bookings",
    "revenue": "Revenue",
    "open_offers": "Open offers",
    "published": "Published",
    "not_published": "Not published",
    "publish": "Publish showcase",
    "unpublish": "Unpublish",
    "view_showcase": "View public showcase",
    "copy_link": "Copy link",
    "copied": "Copied!",
    "save": "Save changes",
    "saved": "Saved",
    "name": "Name",
    "city": "City",
    "region": "Region",
    "address": "Address",
    "country": "Country",
    "country_help": "Where the building is: identifiers and deadlines come from here.",
    "locality": "Municipality / locality",
    "currency": "Currency",
    "currency_help": "The country's currency. Room prices and charges are still in euro: the site converts for display only.",
    "obligations_title": "Country obligations",
    "obligations_hint": "What must be reported, to whom and by when. The list follows the property's country: move the property and the obligations change.",
    "obligations_active": "Active",
    "obligations_toggle": "Mark as active",
    "obligations_source": "Official source",
    "obligations_verified": "Verified on",
    "obligations_error": "I can't save the obligation",
    "timezone": "Time zone",
    "phone": "Phone",
    "desc_it": "Description (IT)",
    "desc_en": "Description (EN)",
    "amenities": "Amenities (comma separated)",
    "hero_image": "Hero image",
    "photos": "Photo gallery",
    "property_type": "Property type",
    "add_room": "Add room",
    "room_name": "Room name",
    "price_night": "Price/night (€)",
    "capacity": "Capacity",
    "photo_url": "Photo URL",
    "publish_offer": "Post to network",
    "no_bookings": "No bookings yet",
    "no_rooms": "No rooms yet. Add one to get started.",
    "offer_from": "From",
    "offer_to": "To",
    "post_group_req": "Post group request",
    "title": "Title",
    "guests": "Guests",
    "budget": "Budget/night (€)",
    "notes_it": "Notes (IT)",
    "notes_en": "Notes (EN)",
    "respond": "Respond",
    "rooms_offered": "Rooms offered",
    "message": "Message",
    "send": "Send response",
    "responses": "responses",
    "total": "Total",
    "night": "night",
    "nights": "nights",
    "upload_photo": "Upload photo",
    "uploading": "Uploading...",
    "drop_here": "Drop or click to upload",
    "remove": "Remove",
    "ical_title": "OTA Sync via iCal",
    "ical_sub": "Import availability and bookings from Booking, Airbnb, Expedia, Vrbo.",
    "ical_url": "iCal URL",
    "ical_source": "Platform",
    "ical_import": "Import",
    "ical_last_sync": "Last sync",
    "ical_events": "Imported events",
    "calendar_unified": "Unified calendar",
    "swap_forward": "Forward to partner",
    "swap_title": "Room swap",
    "partner_property": "Partner property",
    "partner_room": "Partner room",
    "commission_10": "10% commission will be applied",
    "swap_notes": "Notes to the partner",
    "swap_send": "Propose swap",
    "no_swaps": "No swaps yet",
    "breakfast_title": "Centralized breakfast",
    "breakfast_sub": "Offer or book breakfast covers for guests in the network.",
    "add_breakfast_slot": "New breakfast slot",
    "slot_date": "Date",
    "slot_time": "Time",
    "slot_max": "Max covers",
    "slot_price": "Price/cover (€)",
    "book_covers": "Book covers",
    "covers": "covers",
    "book_slot": "Book",
    "available": "available",
    "your_breakfast_bookings": "Your breakfast bookings",
    "role": "Role",
    "date": "Date",
    "amount": "Amount",
    "source": "Source",
    "event_title": "Title",
    "start": "Start",
    "end": "End",
    "no_events": "No events yet — import an iCal or receive a booking.",
    "welcome_back": "Welcome back",
    "toast_uploaded": "Uploaded",
    "toast_upload_failed": "Upload failed",
    "toast_error": "Error",
    "toast_swap_sent": "Swap proposed · guest notified",
    "toast_slot_added": "Slot added",
    "toast_slot_booked": "Booked",
    "toast_offer_posted": "Offer posted",
    "toast_gr_posted": "Request posted",
    "toast_response_sent": "Response sent",
    "toast_imported": "Imported {n} events",
    "select_room": "Select room",
    "select_partner": "Select partner",
    "select_booking": "Select booking",
    "no_paid_bookings": "No paid bookings",
    "per_cover": "per cover",
    "outgoing": "outgoing",
    "incoming": "incoming",
    "from_label": "From:",
    "to_label": "To:",
    "commission_10pct": "Commission (10%)",
    "analytics": "Analytics",
    "revenue_monthly": "Monthly revenue",
    "direct_bookings": "Direct bookings",
    "swap_commissions": "Swap commissions",
    "breakfast_income": "Breakfast income",
    "no_analytics": "No data yet — start receiving bookings.",
    "stripe_connect": "Automatic payouts",
    "connect_start": "Enable Stripe Connect",
    "connect_continue": "Complete onboarding",
    "connect_done": "Payouts active",
    "connect_pending": "Onboarding in progress",
    "connect_hint": "Direct bookings arrive automatically net of the Hostaly commission (8% Base · 6% Pro · 4.5% Enterprise). Stripe payment processing fees are borne by the connected account.",
    "accept_split": "Accept & split",
    "select_partners": "Select partners",
    "allocated_rooms": "Allocated rooms",
    "allocation_confirmed": "Allocation confirmed",
    "push_title": "Browser notifications",
    "push_hint": "Get an alert on your device even when the tab is closed.",
    "push_enable": "Enable",
    "push_disable": "Disable",
    "push_on": "On",
    "push_off": "Off",
    "push_denied": "Blocked by browser",
    "instagram": "Instagram",
    "ig_handle": "Instagram handle (@)",
    "ig_posts": "Recent posts",
    "ig_add": "Add post",
    "ig_image": "Image URL",
    "ig_caption": "Caption",
    "ig_link": "Post link",
    "verification": "Verification",
    "verify_title": "Property verification",
    "verify_hint": "Verified structures show a ✓ badge on the marketplace and vetrina.",
    "verified": "Verified",
    "pending_verify": "Pending",
    "not_verified": "Not verified",
    "submit_verify": "Request verification",
    "vat_number": "VAT number (11 digits)",
    "business_name": "Business name",
    "municipality": "Municipality",
    "declaration": "I declare that this information is correct",
    "admin": "Administration",
    "admin_pending": "Pending requests",
    "approve": "Approve",
    "reject": "Reject",
    "admin_note": "Internal note",
    "ai_copy": "Generate with AI",
    "ai_copy_title": "Generate vetrina with AI",
    "ai_copy_hint": "Enter a few keywords — AI will craft IT/EN copy + amenities.",
    "ai_keywords": "Keywords (comma separated)",
    "ai_tone": "Tone",
    "ai_generate": "Generate",
    "ai_apply": "Apply to vetrina",
    "promo_code": "Promo code",
    "promo_apply": "Apply",
    "promo_valid": "Code valid",
    "promo_saved": "You save",
    "trade_nav": "Trade B2B",
    "trade_title": "B2B for tour operators and agencies",
    "trade_sub": "Buy room blocks directly from Italian structures at wholesale rates.",
    "trade_offers": "Trade offers",
    "trade_login": "Trade sign in",
    "trade_register": "Register agency",
    "trade_company": "Agency / tour operator name",
    "trade_vat": "VAT number",
    "trade_country": "Country",
    "trade_publish": "Publish trade offer",
    "trade_new_offer": "New trade offer",
    "trade_rooms_available": "Rooms available",
    "trade_price_per_night": "Price/room/night (€)",
    "trade_min_nights": "Min nights",
    "trade_buy": "Buy now",
    "trade_orders_mine": "My orders",
    "trade_sold": "sold",
    "trade_tab": "Trade",
    "partner_center_tab": "Partner Center",
    "channels_tab": "OTA Channels",
    "b2b_title": "B2B channel · bedbank",
    "b2b_subtitle": "Buy net rates from a bedbank, apply your markup and rebate the commission to the partner.",
    "b2b_suppliers": "Suppliers",
    "b2b_add_supplier": "Add supplier",
    "b2b_mapping": "Hotel mapping",
    "b2b_rules": "Price rules",
    "b2b_simulator": "Simulator",
    "b2b_settlements": "Settlements",
    "b2b_net": "Net rate",
    "b2b_nights": "Nights",
    "b2b_markup": "Markup",
    "b2b_rebate": "Rebate",
    "b2b_msp": "Minimum price (MSP)",
    "b2b_gross": "Public price",
    "b2b_charged": "Collected now",
    "b2b_margin": "Margin",
    "b2b_blocked": "Not sellable",
    "b2b_msp_binding": "Price held by the supplier minimum",
    "b2b_cashback": "Rebate is paid after the booking",
    "b2b_needed_markup": "Required markup",
    "b2b_target_margin": "Target margin",
    "b2b_credentials_missing": "Missing credentials",
    "b2b_confirmed_by": "Confirmed by",
    "b2b_auto": "Auto-linked",
    "b2b_review": "Needs review",
    "b2b_no_candidates": "No compatible candidate",
    "b2b_partners": "Counterparties",
    "b2b_add_partner": "Add counterparty",
    "b2b_partner_kind": "Type",
    "b2b_partner_agency": "Agency",
    "b2b_partner_tour_operator": "Tour operator",
    "b2b_partner_hotel": "Another hotel",
    "b2b_partner_vat": "VAT number",
    "b2b_payment_terms": "Payment terms",
    "b2b_credit_risk": "Bad-debt provision",
    "b2b_credit_limit": "Credit limit",
    "b2b_terms_agency": "Agencies and hotels only: no consumer checkouts, so no card payments.",
    "b2b_outstanding": "Outstanding",
    "b2b_rates": "Counterparty rates",
    "b2b_net_rate": "Net rate",
    "b2b_public_price": "Public price",
    "b2b_above_public": "Above the public price",
    "b2b_above_public_hint": "You are asking the counterparty more than you ask a guest coming from the vetrina. The agency notices and routes around you."
  },
  "vetrina": {
    "book": "Book",
    "from": "from",
    "per_night": "/ night",
    "rooms": "Rooms",
    "reviews": "Reviews",
    "contact": "Contact",
    "leave_review": "Leave a review",
    "guest_name": "Your name",
    "rating": "Rating",
    "comment": "Your comment",
    "submit": "Submit review",
    "services": "Services",
    "check_in": "Check-in",
    "check_out": "Check-out",
    "guest_email": "Your email",
    "confirm_book": "Confirm & pay",
    "total_price": "Total",
    "processing": "Processing...",
    "book_this_room": "Book this room",
    "promo_code": "Promo code",
    "promo_apply": "Apply",
    "promo_valid": "Code valid",
    "promo_saved": "You save",
    "traveller_nudge": "Are you a traveller?",
    "prefill_login": "Log in to prefill your details →",
    "beds": "Beds",
    "beds_hint": "Price per bed: {count} beds available in this dorm.",
    "phone": "Phone",
    "phone_optional": "Phone (optional)",
    "phone_placeholder": "+44 7700 900123",
    "phone_hint": "The host will only use it for booking-related contact.",
    "charged_in": "Charged in {currency} · {amount}",
    "fx_note": "ECB rate: 1 EUR = {rate} {currency} ({date})",
    "fx_stale": "last available rate",
    "pay_now": "Pay now",
    "pay_now_hint": "Card · immediate charge",
    "pay_at_property": "Pay at property",
    "pay_at_property_hint": "Card guarantee · charged only on no-show",
    "pay_at_hotel": "Pay at the hotel",
    "pay_at_hotel_hint": "Pay everything at check-in · a card guarantee is required",
    "pay_at_hotel_title": "Pay everything at check-in, at the property",
    "pay_at_hotel_step1": "Nothing is charged now: you settle the full stay at check-in, directly with the property.",
    "pay_at_hotel_step2": "A valid credit card is required to guarantee the booking. It is not charged today: we keep it as a guarantee only.",
    "pay_at_hotel_step3": "The card is charged only on a no-show or a late cancellation, according to the property's policy.",
    "pay_at_hotel_total": "Total to pay at the property",
    "pay_at_hotel_continue": "Continue with the card guarantee",
    "pay_at_hotel_unavailable": "The card guarantee is not available right now: book with card payment or contact the property.",
    "paypal_hint": "Pay with your PayPal account",
    "pay_with_paypal": "Pay with PayPal",
    "paypal_note": "You'll be redirected to PayPal to complete the payment securely, then come back here.",
    "redirecting": "Redirecting…",
    "enter_email_code": "Enter email and code",
    "invalid_code": "Invalid code",
    "phone_invalid": "Please enter a valid phone number",
    "name_email_required": "Name and email required",
    "pick_dates": "Pick your dates",
    "accept_policy": "You must accept the no-show policy to continue",
    "report_content": "Report content",
    "guest_terms": "Booking terms",
    "free_cancel": "Free cancellation",
    "no_show_policy": "No-show policy",
    "penalty": "Penalty",
    "free_cancel_note": "You can cancel free of charge up to {days} days before check-in.",
    "free_cancel_note_one": "You can cancel free of charge up to 1 day before check-in.",
    "by_date": "By {date}.",
    "then_retained": "After that, {percent}% is retained.",
    "penalty_note": "Cancellation is subject to a penalty of {penalty}.",
    "first_night": "first night",
    "percent_of_total": "{percent}% of total",
    "guarantee_card": "Guarantee card",
    "no_charge_note": "No charge now. We will only run a temporary €1 verification (released immediately) to validate the card.",
    "no_show_consent": "I accept that on a no-show after the deadline, {amount} will be charged to the card above.",
    "confirm_no_charge": "Confirm booking (no charge)",
    "please_wait": "Please wait…",
    "booking_confirmed": "Booking confirmed · Card •••• {last4} on file",
    "verified": "Verified",
    "guest_favourite": "Guest favourite",
    "guest_favourite_hint": "Guest favourite — awarded to the most appreciated stays",
    "rates_loading": "Loading rates...",
    "per_bed_night": "per bed / night",
    "dorm_badge": "{gender} dorm · {beds} beds",
    "floor": "Floor {number}",
    "free_cancel_badge": "Free cancellation up to {days} days before",
    "guest": "Guest",
    "thanks": "Thanks!",
    "posting_as": "Posting as",
    "rating_5": "Perfect",
    "rating_4": "Good",
    "rating_3": "Fair",
    "rating_2": "Poor",
    "rating_1": "Very bad",
    "dictate_review": "Dictate your review",
    "gender_mixed": "mixed",
    "gender_female": "female",
    "gender_male": "male"
  },
  "guest": {
    "my_bookings": "My bookings",
    "my_maps": "My maps",
    "travellers_area": "Traveller area",
    "have_account": "Already have an account?",
    "login": "Log in",
    "signup": "Sign up"
  },
  "pay": {
    "success": "Booking confirmed",
    "success_body": "You'll receive a confirmation email. Thank you!",
    "cancel": "Payment canceled",
    "cancel_body": "No charge was made.",
    "back_home": "Back home",
    "checking": "Checking payment status..."
  },
  "common": {
    "close": "Close",
    "cancel": "Cancel",
    "loading": "Loading...",
    "city": "City",
    "filter_city": "Filter by city"
  },
  "trip_group": {
    "propose_title": "Other guests on your dates",
    "propose_caption": "There is a travellers' group for {from} → {until}. You can join, even just to chat: no obligation to move together.",
    "joined_title": "You're in the group",
    "joined_caption": "The group chat is open while your dates overlap.",
    "join": "Join",
    "more": "How it works",
    "consent_note": "Joining enables traveller-group consent. It is generic and revocable: no obligation to travel together.",
    "consent_enable": "Enable participation",
    "optin_badge": "Solo travellers",
    "optin_title": "Travelling solo? Others are doing your same experiences.",
    "optin_caption": "On your dates someone is visiting, eating and walking where you're going: join the group and share only what you feel like.",
    "optin_body": "Joining is confirmed only when the trip happens and you can withdraw whenever you like, with no effect on your booking.",
    "optin_on": "Opted in",
    "optin_off": "Not joining",
    "optin_saved": "Preference saved. You can change it any time.",
    "optin_login": "Sign in as a traveller to turn it on",
    "optin_error": "I can't save your preference.",
    "login_required": "Sign in to join the group.",
    "join_failed": "I can't add you to the group.",
    "cap_reached": "You're already in 2 overlapping groups: leave one to join this one.",
    "tooltip_title": "Traveller groups",
    "tooltip_1": "Groups are by place and period: one shared day of stay is enough.",
    "tooltip_2": "You can be in several groups, but at most two overlap on the same dates.",
    "tooltip_3": "The chat is open only during the shared dates: messages outside those dates are not delivered.",
    "tooltip_4": "Other members see only a short name, never the details of your booking.",
    "tooltip_5": "Cancel the booking and you leave the group; if you're the only one left, the group closes.",
    "tooltip_window": "Period",
    "loading": "Loading...",
    "back": "Back",
    "chat_title": "Group chat",
    "chat_hint": "Only members with overlapping dates see these messages. No booking details are shared.",
    "chat_failed": "I can't load the chat.",
    "send_failed": "Message not sent.",
    "chat_empty": "Write a message.",
    "no_access": "No access",
    "no_access_detail": "The chat is for members with an overlapping stay and is open only during the shared dates.",
    "no_access_after_consent": "Consent is on, but you are not part of this group: the dates no longer overlap, or the group has closed.",
    "not_found": "Group not found",
    "no_messages": "No messages yet. Break the ice.",
    "new_message": "New message",
    "message_placeholder": "Write something to the group...",
    "send": "Send",
    "cancel": "Cancel",
    "announce": "Announcement",
    "announcement": "Announcement",
    "meeting": "Meet-up",
    "meeting_proposal": "Meet-up proposal",
    "new_meeting": "Propose a meet-up",
    "meeting_when": "When",
    "meeting_when_placeholder": "e.g. Saturday morning",
    "meeting_when_required": "Say when.",
    "meeting_where": "Where",
    "meeting_where_placeholder": "e.g. the museum entrance",
    "meeting_where_required": "Say where.",
    "meeting_note": "Note (optional)",
    "meeting_note_placeholder": "Anything to add?",
    "propose": "Propose",
    "members": "Members",
    "member_count": "Members: {n}",
    "no_members": "No members yet.",
    "anonymous": "Guest",
    "chat_ok": "In chat",
    "chat_no": "Group only"
  }
};
